import { ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';
import { animated } from 'react-spring';

var PREFIX = "KFavoriteButton";
var classes = {
    icon: "".concat(PREFIX, "-icon")
};
var StyledKFavoriteButton = styled(animated(ButtonBase))(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            position: "absolute",
            top: theme.spacing(1),
            right: theme.spacing(1),
            padding: 0,
            margin: 0,
            color: theme.palette.background.paper,
            borderRadius: "50%",
            cursor: "pointer",
            appearance: "none",
            outline: "none",
            height: "1.5rem",
            width: "1.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // Expanding click area
            "& > div:first-of-type": {
                position: "absolute",
                left: theme.spacing(-1),
                top: theme.spacing(-1),
                width: "calc(100% + ".concat(theme.spacing(2), ")"),
                height: "calc(100% + ".concat(theme.spacing(2), ")")
            },
            // Button design
            "& > span:first-of-type": {
                content: '"&nbsp;"',
                position: "absolute",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                border: "2px solid transparent",
                borderRadius: "50%"
            },
            "&:focus-within": {
                "& > span:first-of-type": {
                    borderColor: theme.palette.primary.main
                }
            }
        },
        _b["& .".concat(classes.icon)] = {
            color: theme.palette.primary.main
        },
        _b);
});

export { classes, StyledKFavoriteButton as default };
//# sourceMappingURL=index.styled.js.map
